import React from 'react'
import SbEditable from 'storyblok-react'
import Label from 'src/components/Label';
import Heading from 'src/components/Heading';
import Wave from 'src/utils/Wave';
import SimpleThreeColumnItem from './SimpleThreeColumnItem';

const SimpleThreeColumn = ({ blok }) => {
    return (
        <SbEditable content={blok}>
            <div className="py-16 lg:py-28 bg-blue">
                <div className="max-w-7xl mx-auto px-6 pb-16 2xl:max-w-screen-2xl">
                    <Label className="text-teal">{blok.label}</Label>
                    <Heading size="h2" className="text-white max-w-2xl my-6">{blok.title}</Heading>
                    <p className="text-[#9890AA] lg:text-base text-sm max-w-xl tracking-[-0.01em]">{blok.description}</p>
                </div>
            </div>
            <Wave size="small" className="fill-blue"/>
            <div className="max-w-7xl mx-auto px-6 2xl:-mt-48 lg:-mt-40 -mt-28 lg:mb-32 mb-16 2xl:max-w-screen-2xl">
                <dl className="grid lg:grid-cols-3 grid-cols-1 xl:gap-16 lg:gap-4 gap-8">
                    {blok.columns.map((item, index) => (
                        <SimpleThreeColumnItem props={{...item, index}} key={index}/>
                    ))}
                </dl>    
            </div>
        </SbEditable>  
    )
}

export default SimpleThreeColumn